<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_ptb0lr24 s_bf p-t-24">
      <div class="mb25">
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">
          <a-button size='small' @click="()=>{$router.go(-1)}" class="mr10">
            <LeftOutlined />返回
          </a-button>
          订单操作
        </p>
        <div class="s_p24">
          <p class="s_c333  s_lin_h35 s_fonts16"><span class="m-r-15">订单状态：<span style="color:#05486a">{{orderData.order_status_text}}</span></span><span>订单号：{{orderData.order_no}}<span class="s_c999">（{{orderData.receive_type}}）</span></span></p>
          <a-divider :hidden='orderData.order_status == 9' />
          <div class="s_flex_ali" :hidden='orderData.order_status == 4'>
            <p class="m-r-10">你可以：</p>
            <a-button class="m-r-15" type="primary" v-if='(orderData.order_status == 1 || orderData.order_status == 2)' v-has:orderEditAddress='getAddress'>修改地址</a-button>
            <a-button class="m-r-15" type="primary" v-if='(orderData.order_status == 1 )' v-has:deliverGoods='()=>orderDeliver(1)'>发货</a-button>
            <a-button class="m-r-15" type="primary" v-if='(orderData.order_status == 2) ' v-has:orderDetailLogistics='getLogistics'>物流信息</a-button>
            <!-- <a-button class="m-r-15" type="primary" v-if='orderData.order_status == 1 && orderData.order_type !== 5' v-has:orderDetailRefunds='orderRefunds'>退款</a-button> -->
            <!-- <a-button class="m-r-15" type="primary" v-if='orderData.order_status == 2 && orderData.delivery_type == 1' @click='orderDeliver(2)'>修改发货</a-button> -->
            <!-- <a-button type="danger" v-if='orderData.order_status == 5 && orderData.order_type !== 5' v-has:orderDetailAfter="()=> {$router.push('/order/order_manage/return_order_more?id='+$route.query.id)}">售后处理</a-button> -->
            <a-button type="primary" ghost v-has:orderEditRemarks='getRemarks' v-if="orderData.order_status != 4">订单备注</a-button>
          </div>
          <div class="s_flex_ali m-t-20 p-15 s_bf7 m-l-70" v-if='orderData.store_remark'>
            订单备注：{{orderData.store_remark}}
          </div>
        </div>
      </div>
      <div class="mb25">
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">订单详情</p>
        <div class="s_p24">
          <p class="s_c333  s_lin_h35">订单类型：{{orderData.order_type_text}}</p>
          <p class="s_c333  s_lin_h35">
            收货信息：{{orderData.delivery_type == 1 ? orderData.name :  orderData.extract_name}}，{{orderData.delivery_type == 1 ? orderData.phone : orderData.extract_phone}}，{{orderData.area}}
          </p>
          <!-- <p class="s_c333  s_lin_h35">{{$route.query.is_activity?'发货方式：':'领取方式：'}}{{orderData.delivery_type_text}}</p> -->
          <p class="s_c333  s_lin_h35">发货门店：{{orderData.store_name}}</p>
          <p class="s_c333  s_lin_h35">所属上级：{{orderData.parent_name}}</p>
          <p class="s_c333  s_lin_h35">应付金额：<span v-if="orderData.pay_type==1">{{orderData.total_pay_point}} 积分</span><span v-else>{{orderData.total_pay_point}} 积分 + ￥ {{orderData.total_pay_price}}</span></p>

          <p class="s_c333  s_lin_h35">支付方式：{{orderData.pay_type_text}}</p>
          <p class="s_c333  s_lin_h35">交易号：{{orderData.adpay_current_no || '-'}}</p>
          <p class="s_c333  s_lin_h35">付款时间：{{orderData.pay_time || '-'}}</p>
          <p class="s_c333  s_lin_h35">物流公司：{{orderData.express_company || '-'}}</p>
          <p class="s_c333  s_lin_h35">物流单号：{{orderData.express_no || '-'}}</p>
          <p class="s_c333  s_lin_h35">发货时间：{{orderData.delivery_time || '-'}}</p>
          <p class="s_c333  s_lin_h35">签收时间：{{orderData.signing_time || '-'}}</p>
          <!-- <p class="s_c333  s_lin_h35">买家留言：{{orderData.buyer_remark || '暂无留言'}}</p> -->
          <!-- <a-divider /> -->
          <!-- <p class="s_c333 s_fonts14  m-b-20">买家信息：</p> -->
          <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333 m-t-20 m-b-20" style="margin-left:-18px;width:103%">商品清单：</p>
          <!-- <div class="s_flex_bian_c">
            <p class="width30 s_c333 ">微信昵称：{{orderData.member_name}}</p> -->
          <!-- <p class="width30 s_c333 ">会员ID：{{orderData.user_id}}</p> -->
          <!-- <p class="width30 s_c333 ">会员等级：{{orderData.vip_level}}</p> -->
          <!-- </div> -->
          <!-- <a-divider /> -->
          <!-- <p class="s_c333 s_fonts14  m-b-20">商品清单：</p> -->
          <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columnsGood' :data-source='orderData.product_list'>
            <template v-slot:good="{ record }">
              <a-card-meta>
                <template #avatar>
                  <img :src="info.picdomain+'/'+(record.gift_image)" alt="" style="width:50px;height:50px" class="s_bor5">
                </template>
                <template #description>
                  <p class="s_omit">{{record.gift_name}}</p>
                </template>
              </a-card-meta>
            </template>
            <template v-slot:product_price="{ record }">
              <!-- <p>￥{{record.product?record.product.product_price : '-'}}<span v-if="orderData.order_type == 5">+{{record.product?record.product.point: '-'}}积分</span></p> -->
              <p>
                <span class="s_cd41" v-if="record.pay_type==1">{{record.gift_market_point || 0}} 积分</span>
                <span class="s_cd41" v-if="record.pay_type==2">{{record.gift_market_point || 0}} 积分 + ￥ {{record.gift_market_price  || '0.00'}}</span>
              </p>
            </template>
            <template v-slot:buy_num="{ record }">
              <a v-if="orderData.gift_type==2" @click="()=>handeletotal(orderData)">{{record.buy_num}}</a>
              <p v-else>{{record.buy_num}}</p>
            </template>
          </a-table>
          <div class="s_flex_bian m-t-25">
            <div class="s_c333 ">
              <span class="m-r-20">商品数量总计：{{orderData.buy_num || 0}} 件</span>
            </div>
            <div class="s_c333 ">
              <p class="m-b-10">商品总金额：<span v-if="orderData.pay_type==1">{{orderData.total_pay_point || 0}} 积分</span><span v-if="orderData.pay_type==2">{{orderData.total_pay_point || 0}} 积分 + ￥ {{orderData.gift_market_price * orderData.buy_num}}</span></p>
              <p class="m-b-5"> 运费：¥ {{orderData.freight_price}}</p>
              <p>订单金额：
                <span class="fz-18 s_cd41">{{orderData.total_pay_point || 0}} 积分 <span v-if="orderData.total_pay_price>0">+ ￥{{orderData.total_pay_price || '0.00'}}</span></span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="mb25">
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">操作记录</p>
        <div class="s_p24">
          <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columnsRecord' :data-source='orderData.operation_log'>
            <template v-slot:user="{ record }">
              <p>{{record.operator_type_text || '-'}}</p>
            </template>
          </a-table>
        </div>
      </div>
    </div>
    <a-modal :keyboard="false" title="订单备注" centered v-model:visible="showRemarks" :confirm-loading="confirmLoading" @ok="eidtRemarks" destroyOnClose>
      <a-textarea v-model:value="orderRemarks" placeholder="请输入订单备注内容" :rows="4" />
    </a-modal>
    <a-modal :keyboard="false" title="修改收货地址" :width='600' centered :footer="null" v-model:visible="showAddress" destroyOnClose>
      <addressChange :addressData='addressData' :type='true' v-on:submitdeliver='submitAddress'></addressChange>
    </a-modal>

    <a-modal :keyboard="false" title="发货" :width='1000' centered :footer="null" v-model:visible="showDeliver" destroyOnClose>
      <deliverForem :deliverData='deliverData' :type='3' :isInsteadShip='1' v-on:submitdeliver='submitdeliver'></deliverForem>
    </a-modal>
    <a-modal :keyboard="false" title="物流信息" :width='800' centered :footer="null" v-model:visible="showLogistics" destroyOnClose>
      <logisticsDetails :data='logisticsData'></logisticsDetails>
    </a-modal>
        <a-modal :keyboard="false" centered v-model:visible="isTotal" :width='1200' :footer="null" destroyOnClose>
      <RedeemCode :order_no='order_no'></RedeemCode>
    </a-modal>
  </a-layout>
</template>

<script>
import {
  guideOrderDetails,
  guideOrderDelivery,
  guideOrderReceiveAddress,
  guideOrderStoreRemark,
  guideOrderLogistics,
} from "@/api/guide";
import { LeftOutlined } from "@ant-design/icons-vue";
import { onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import store from "@/store";

import { iscode } from "@/utils/app";
import logisticsDetails from "../components/logisticsDetails";
import RedeemCode from "./RedeemCode.vue";
export default {
  components: {
    LeftOutlined,
    logisticsDetails,
    RedeemCode
  },
  setup() {
    const state = reactive({
      showAddress: false,
      showRefunds: false,
      showDeliver: false,
      listLoading: false,
      showRemarks: false,
      showLogistics: false,
      addressData: {},
      deliverData: {},
      refundsData: {},
      orderRemarks: "",
      deliverType: 1,
      confirmLoading: false,
        order_no: "",
      isTotal: false,
      info: store.state.user.info,
      orderData: {
        extract: {},
      },
      allNum: 0,
      allWeight: 0,
      logisticsData: {},
    });
    let columnsGood = [
      {
        title: "商品信息",
        key: "gift_name",
        slots: { customRender: "good" },
      },
      {
        title: "规格",
        dataIndex: "gift_sku_name",
        key: "gift_sku_name",
      },
      {
        title: "数量",
        dataIndex: "buy_num",
        key: "buy_num",
        slots: { customRender: "buy_num" },
      },
      {
        title: "售价",
        dataIndex: "product_price",
        key: "product_price",
        slots: { customRender: "product_price" },
      },
      // {
      //   title: "优惠",
      //   dataIndex: "coupon_price",
      //   key: "coupon_price",
      //   slots: { customRender: "coupon_price" },
      // },
      // {
      //   title: "小计",
      //   dataIndex: "total_pay_price",
      //   key: "total_pay_price",
      //   slots: { customRender: "total_pay_price" },
      // },
    ];
    let columnsRecord = [
      {
        title: "操作时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "操作人",
        dataIndex: "user",
        key: "user",
        slots: { customRender: "user" },
      },
      {
        title: "操作动作",
        dataIndex: "type_text",
        key: "type_text",
      },
      {
        title: "信息",
        dataIndex: "remark",
        key: "remark",
      },
    ];
    const $route = inject("$route");

    //获取备注
    const getRemarks = async (e) => {
      // let res = await getOrderRemark({ order_no: $route.query.id }).then((res) => res.data).catch((error) => error);
      // if (iscode(res)) {
      //   state.showRemarks = true;
      //   state.orderRemarks = res.data.store_remark;
      // } else {
      //   message.error(res.msg);
      // }
      state.showRemarks = true;
      state.orderRemarks = state.orderData.store_remark || "";
    };
    //修改备注
    const eidtRemarks = async () => {
      // state.confirmLoading = true;
      const hide = message.loading("正在加载中...", 0);
      let remarksData = {
        order_no: $route.query.id,
        store_remark: state.orderRemarks,
      };
      let res = await guideOrderStoreRemark({ ...remarksData })
        .then((res) => res.data)
        .catch((error) => error);
      setTimeout(hide);
      if (iscode(res)) {
        state.showRemarks = false;

        initData();
      } else {
        message.error(res.msg);
      }
      // state.confirmLoading = false;
    };
    //获取订单地址
    const getAddress = async (e) => {
      state.addressData = {
        name: state.orderData.extract_name,
        phone: state.orderData.extract_phone,
        detail: state.orderData.area.split(",")[1],
        province_id: state.orderData.province_id,
        city_id: state.orderData.city_id,
        region_id: state.orderData.region_id,
        city_texts: state.orderData.area.split(",")[0],
        id: state.orderData.extract_id,
      };
      state.showAddress = true;
    };
    //确认修改地址
    const submitAddress = async (data) => {
      console.log(data);
      const hide = message.loading("正在加载中...", 0);
      let res = await guideOrderReceiveAddress({
        ...data,
        detail: data.detail.split(",")[1],
      }).then((res) => res.data);
      setTimeout(hide);
      if (iscode(res, true)) {
        state.showAddress = false;
        initData();
      }
    };

    //退货
    const submitrefunds = () => {
      state.showRefunds = false;
      initData();
    };
    //打开发货弹窗
    const orderDeliver = (type) => {
      state.deliverType = type;
      const { buy_num, gift_image, gift_name } = state.orderData;
      state.deliverData = {
        order_no: $route.query.id,
        detail: [
          {
            product_image: gift_image,
            product_name: gift_name,
            buy_num: buy_num,
          },
        ],
        extract: {
          extract_name: state.orderData.extract_name,
          extract_phone: state.orderData.extract_phone,
          detail: state.orderData.area,
        },
      };
      state.showDeliver = true;
    };
        const handeletotal = async (e) => {
      console.log(e);
      state.isTotal = true;
      state.order_no = e.order_no;
    };
    //发货
    const submitdeliver = async (data) => {
      const hide = message.loading("正在加载中...", 0);
      let orderData = {
        ...data,
        order_no: $route.query.id,
      };
      let res = await guideOrderDelivery({ ...orderData }).then(
        (res) => res.data
      );
      setTimeout(hide);
      if (iscode(res, true)) {
        state.showDeliver = false;
        initData();
      }
    };
    //获取物流信息
    const getLogistics = async () => {
      let res = await guideOrderLogistics({ order_no: $route.query.id })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        state.showLogistics = true;
        state.logisticsData = res.data;
      } else {
        message.error(res.msg);
      }
    };
    //获取详情
    const initData = async () => {
      const hide = message.loading("正在加载中...", 0);
      let res = await guideOrderDetails({ order_no: $route.query.id }).then(
        (res) => res.data
      );
      state.listLoading = false;
      if (iscode(res)) {
        state.orderData = res.data;
        const {
          buy_num,
          gift_market_price,
          gift_market_point,
          pay_type,
          gift_image,
          gift_name,
          gift_sku_name,
        } = res.data;
        state.orderData.product_list = [
          {
            buy_num,
            gift_market_price,
            gift_market_point,
            pay_type,
            gift_image,
            gift_name,
            gift_sku_name,
          },
        ];
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    };

    onMounted(() => {
      initData();
    });
    return {
      columnsRecord,
      columnsGood,
      ...toRefs(state),
      submitAddress,
      eidtRemarks,
      getRemarks,
      getAddress,
      orderDeliver,
      submitrefunds,
      submitdeliver,
      getLogistics,
      handeletotal
      // goBack
    };
  },
};
</script>

